

<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <div v-if='isContractExpired'>
                <p class="errorLabel" v-if='expiredType == "after"'> 契約期限が切れました。お問い合わせください。</p>
                <p class="errorLabel" v-else> 契約開始前です。</p>
              </div>
              <CForm >
                <h1>ログイン</h1>
                <p class="text-muted">IDとパスワードを入力し、ログインしてください</p>
                <CInput
                  placeholder="E-mail"
                  autocomplete="email"
                  v-model="email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  placeholder="パスワード"
                  type="password"
                  autocomplete="curent-password"
                  v-model="password"
                  class="mt-2"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="12" class="text-center">
                    <CButton @click="login" color="primary" class="px-4 mt-3">ログイン</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>

</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import moment from "moment";
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      email: '',
      password: '',
    }
  },
  methods: {
    login () {
      axios
      .post(process.env.VUE_APP_API_ENDPOINT + "/api/mng/auth_login", {"email": this.email, "password": this.password})
      .then((resp) => {
        if(resp.status == 200) {
          localStorage.setItem('access_token', resp.data.access_token)
          localStorage.setItem('role', resp.data.user.role)
          localStorage.setItem('is_auth', true)
          const expiredTime = moment().add(1, 'hours').unix()
          localStorage.setItem("expired_at", expiredTime)
          this.notifyVue("Success")
          this.$router.push('/')
        }
      }).catch(error => {
        this.notifyVue(error.response.data.errors[0], 'error')
      })
    },
  },
  computed: {
    ...mapGetters({
      isContractExpired:'GetIsContractExpired',
      expiredType:'GetExpiredType',
    })
  },

}
</script>
